// Manually maintained — Rails 8's Stimulus register-per-controller pattern.

import { application } from "./application"

import GiveWizardController from "./give_wizard_controller"
application.register("give-wizard", GiveWizardController)

import DisclosureController from "./disclosure_controller"
application.register("disclosure", DisclosureController)

import MapToggleController from "./map_toggle_controller"
application.register("map-toggle", MapToggleController)

import EventFilterController from "./event_filter_controller"
application.register("event-filter", EventFilterController)
